import ConditionalToolTip from "components/design/conditionalToolTip";
import { Avatar } from "components/DesignSystem/AvatarGroup/Avatar";

export const AvatarCell = ({
  profileUrl,
  name,
}: {
  profileUrl?: string | null;
  name?: string;
}) => {
  return (
    <ConditionalToolTip condition={name && name}>
      <div
        className="t-min-w-14 t-flex t-justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        {name ? <Avatar alt={name} src={profileUrl || ""} /> : "-"}
      </div>
    </ConditionalToolTip>
  );
};
